// eslint-disable-next-line import/no-extraneous-dependencies
import { initializeApp } from 'firebase/app';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getAnalytics, logEvent as sendEvent, setUserProperties } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyC7FDzqnARNYOnxh0WyAgzZDew_v7nXQTA',
  authDomain: 'hereworks-admin.firebaseapp.com',
  projectId: 'hereworks-admin',
  storageBucket: 'hereworks-admin.appspot.com',
  messagingSenderId: '683063144569',
  appId: '1:683063144569:web:2a2ccf0df17fd882de24a8',
  measurementId: 'G-3V0VQYXDQJ',
};

const app = initializeApp(firebaseConfig);
const webAnalytics = getAnalytics(app);

export function logEvent(screen, name) {
  sendEvent(webAnalytics, name, { screen });
}

export function setClientId(text) {
  setUserProperties(webAnalytics, { clientName: text });
}
